import { useTranslation } from 'react-i18next'
import { useEffect, useRef, useState } from 'react'
import { formatNumbers } from 'core/helpers/format-numbers'
import { openWindow } from 'models/window/actions'
import { useDispatch } from 'react-redux'
import { modalNames } from 'features/modal/constants/names'
import { gameService } from '../../../core/services'
import { useAutoTranslateList } from '../../../core/hooks/useAutoTranslate'

import c from './assets/sass/list.module.scss'

export const List = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const [maxHeight, setMaxHeight] = useState(0)
    const [rawCases, setRawCases] = useState([])
    const [selectedCategory] = useState(null)
    
    // Автоперевод кейсов
    const cases = useAutoTranslateList(rawCases, ['name', 'description'])
    const ref = useRef(null)

    useEffect(() => {
        const updateHeight = () => {
            if (!ref.current) {
                return
            }

            const offsetTop =
                ref.current.getBoundingClientRect().top + window.scrollY
            const height = window.innerHeight - (offsetTop + 85)
            setMaxHeight(height)
        }

        updateHeight()
        window.addEventListener('resize', updateHeight)
        window.addEventListener('scroll', updateHeight)

        return () => {
            window.removeEventListener('resize', updateHeight)
            window.removeEventListener('scroll', updateHeight)
        }
    }, [])

    const openCase = (cs) => {
        dispatch(openWindow(modalNames.GAME_SELECT_MODAL, { caseData: cs }))
    }

    useEffect(() => {
        ;(async () => {
            try {
                const res = await gameService.cases.getCases(selectedCategory)
                // Показываем кейсы выбранной категории
                const arr = res?.cases || []
                setRawCases(arr)
            } catch {}
        })()
    }, [selectedCategory])

    return (
        <div className={c.component}>
            <div className={c.text}>
                <span className={c.subTitle}>
                    {t('profile.cases.subtitle')}
                </span>
            </div>
            
            <div
                className={c.wrapper}
                style={{ height: `${maxHeight}px` }}
                ref={ref}
            >
                <ul className={c.list}>
                    {cases.map((cs) => (
                        <li
                            key={cs.id}
                            className={c.item}
                            onClick={() => openCase(cs)}
                        >
                            <img
                                src={cs.imageUrl || '/images/case-01.png'}
                                alt="Case"
                                className={c.casePic}
                            />
                            <div className={c.caseDetails}>
                                <span className={c.caseTitle}>{cs.name}</span>
                                <span className={c.casePrice}>
                                    {formatNumbers(parseInt(cs.price))}
                                </span>
                            </div>
                            <div className={c.limit}>
                                <span>{cs?.codes?.available ?? 0}</span>/
                                {cs?.codes?.total ?? 0}
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}
